import { useState, useEffect } from "react";
import { LanguageDataType } from "../redux/Slices/languageSlice";

export const useTypingPlaceholder = (
    texts: string[],
    selectedLanguage:LanguageDataType|null,
    typingSpeed: number = 100,
    deletingSpeed: number = 50,
    delay: number = 2000,
) => {
    const language = localStorage.getItem("bsc-lang")
    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isPaused, setIsPaused] = useState(false);


    useEffect(() => {
        if (texts.length === 0) return;

        const timeout = setTimeout(
            () => {
                if (isPaused) {
                    setIsPaused(false);
                    setIsDeleting(true);
                    return;
                }

                if (isDeleting && subIndex === 0) {
                    setIsDeleting(false);
                    setIndex((prev) => (prev + 1) % texts.length);
                    return;
                }

                if (!isDeleting && subIndex === texts[index].length) {
                    setIsPaused(true);
                    return;
                }

                setSubIndex((prev) => prev + (isDeleting ? -1 : 1));
            },
            isPaused ? delay : isDeleting ? deletingSpeed : typingSpeed
        );

        return () => clearTimeout(timeout);
    }, [subIndex, isDeleting, index, texts, typingSpeed, deletingSpeed, delay, isPaused]);

    return texts[index] ? texts[index].substring(0, subIndex) : "";
};
